import store from '@/store/index'
// Fungsi untuk menambah parameter query
export function addQueryParam(key, value) {
    const url = new URL(window.location.href);
    const currentParams = new URLSearchParams(url.search);
    currentParams.append(key, value);
    url.search = currentParams.toString();
    window.history.pushState({}, '', url);
    store.dispatch('set_query_router', [{ key, value }]);
    // location.reload(); // Merefresh halaman
}

// Fungsi untuk mengubah nilai parameter query
export function setQueryParam(key, value) {
    const url = new URL(window.location.href);
    const currentParams = new URLSearchParams(url.search);
    currentParams.set(key, value);
    url.search = currentParams.toString();
    window.history.pushState({}, '', url);
    store.dispatch('set_query_router', [{ key, value }]);
    // location.reload(); // Merefresh halaman
}

// Fungsi untuk mendapatkan query "page" dalam bentuk array
export function getPageQueryArray() {
    const url = new URL(window.location.href);
    const pageParam = url.searchParams.get('page');
    if (pageParam) {
        return pageParam.split(',');
    }
    return [];
}

// Fungsi untuk mendapatkan nilai parameter query berdasarkan nama
export function getQueryParamByName(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
}

// Fungsi untuk menghapus parameter query berdasarkan key
export function deleteQueryParam(key) {
    const url = new URL(window.location.href);
    const currentParams = new URLSearchParams(url.search);

    if (currentParams.has(key)) {
        currentParams.delete(key);
        url.search = currentParams.toString();
        window.history.pushState({}, '', url);
    }
}

// Fungsi untuk menghapus semua parameter query dari URL
export function removeAllQueryParams() {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.pushState({}, '', url);
    store.dispatch('set_query_router', []);
    store.dispatch("remove_all_router_data");
    // location.reload(); // Merefresh halaman
}

export const popStateHandler = ({ getter }) => {
    window.onpopstate = function (event) {
      const location = document.location
      const url = new URL(location.href);
      const currentParams = new URLSearchParams(url.search);
      let history = [];
      for (const [key, value] of currentParams) {
        history.push({
          key,
          value
        });
      }
      if (['checkout', 'payment'].includes(history.find(item => item.key === 'page')?.value) && getter?.dataCartReservation?.length === 0) {
        const url = new URL(window.location.href);
        url.search === "" ? window.location.href = "/" : window.location.replace("/reservation-place")
      } else {
        store.dispatch("remove_all_router_data");
        store.dispatch('set_query_router', history);
      }
      if (process.env.VUE_APP_RESERVATION === 'development') {
          console.log('event state', event.state);
          console.log('onpopstate', document.location);
          console.log('history', history.find(item => item.key === 'page'));
          console.log('getter', getter?.dataCartReservation);
      }
    }
}

// Contoh penggunaan:
// Menambah atau mengedit parameter "page" menjadi "page1,page2,page3"
// updateQueryParam('page', 'page1,page2,page3');

// Mendapatkan query "page" dalam bentuk array
// const pageArray = getPageQueryArray();
// console.log(pageArray);

// Mendapatkan nilai parameter "order"
// const orderValue = getQueryParamByName('order');
// console.log(orderValue);
